import { configureStore } from '@reduxjs/toolkit';
import imagesReducer from './imagesSlice';
import adminReducer from './adminSlice';
import quizzesReducer from './quizzesSlice';
import gamesReducer from './gamesSlice';
import usersReducer from './usersSlice';

export const store = configureStore({
    reducer: {
        imageClicked: imagesReducer,
        adminStats: adminReducer,
        quizzes: quizzesReducer,
        games: gamesReducer,
        users: usersReducer
    }
});